import { render, staticRenderFns } from "./SubVideo.vue?vue&type=template&id=26e102a8&scoped=true&"
import script from "./SubVideo.vue?vue&type=script&lang=js&"
export * from "./SubVideo.vue?vue&type=script&lang=js&"
import style0 from "./SubVideo.vue?vue&type=style&index=0&id=26e102a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e102a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e102a8')) {
      api.createRecord('26e102a8', component.options)
    } else {
      api.reload('26e102a8', component.options)
    }
    module.hot.accept("./SubVideo.vue?vue&type=template&id=26e102a8&scoped=true&", function () {
      api.rerender('26e102a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/SubVideo.vue"
export default component.exports